/**
 * @param {object} config
 * @returns {{ ok: boolean, missing: string[] }}
 */
export function validateDesktopConfig(config) {
  const missing = [];
  if (!config?.mongo_url_configured) missing.push('MONGO_URL');
  if (!config?.jwt_secret_configured) missing.push('JWT_SECRET');
  return { ok: missing.length === 0, missing };
}
